import script from "./TypeTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeTabs.vue?vue&type=script&setup=true&lang=js"

import "./TypeTabs.vue?vue&type=style&index=0&id=c768985e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c768985e"]])

export default __exports__